import { render, staticRenderFns } from "./CorridaInscrevase.vue?vue&type=template&id=2601dd20&scoped=true&"
import script from "./CorridaInscrevase.vue?vue&type=script&lang=js&"
export * from "./CorridaInscrevase.vue?vue&type=script&lang=js&"
import style0 from "./CorridaInscrevase.vue?vue&type=style&index=0&id=2601dd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601dd20",
  null
  
)

export default component.exports